import { useState, useEffect, useMemo } from "react";
import { Box, Button, TextField,IconButton } from "@mui/material";
import { message } from "antd";
import { Save as SaveIcon, Settings as SettingsIcon } from "@mui/icons-material"; // Import Save and Settings icons
import DraggableWrapper from "../../components/common/DraggableWrapper";
import { StrategyEditor } from "../../components/Strategies/Strategies";
import OrderTable from "../../components/DashboardComponent/PositionsOrders";
import {  SquareOffPositions } from "../../utils/services";
import { getToken } from "../../utils/helpers";
import { useAuthContext } from "../../context/AuthContext";
import { API } from "../../utils/constant";

const OptionBuyingTool = ({
    token, strategy,
    setAmount, setTarget, setStopLoss,
    amount, stopLoss, target,
    handleBuy, handleSave,
    traded,setTraded
    // handleSquareOff
}) => {

    const [open, setOpen] = useState(false);
    const [openOrder, setOpenOrder] = useState(true);
    const [OrdersList, setOrdersList] = useState([]);
    const [openStrategyEditor, setOpenStrategyEditor] = useState(false);
    const [squareOffStatus, setSquaringOff] = useState(false);

    const [editable, setEditable] = useState(false);
    const [initialSL, setInitialSL] = useState(stopLoss);
    const [initialTarget, setInitialTarget] = useState(target);
    const [isModified, setIsModified] = useState(false);
    const { user } = useAuthContext();
    const authToken = getToken();

    const memoizedStrategyEditor = useMemo(() => <StrategyEditor strategy={strategy} />, [strategy]);

    const fetchOpenOrders = async () => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const todayStr = `${yyyy}-${mm}-${dd}`;
      
        const url = `${API}/app-orders?` +
          `filters[order_status][$eq]=Open&` +
          `filters[user][documentId]=${user.documentId}&` +
          `filters[createdAt][$gte]=${todayStr}&` +
          `sort=id:asc`;
      
        try {
          const response = await fetch(url, {
            headers: {
              Authorization: `Bearer ${authToken}`, // optional auth
              'Content-Type': 'application/json',
            },
          });
      
          if (!response.ok) {
            throw new Error(`Failed to fetch orders: ${response.status}`);
          }
      
          const data = await response.json();
          console.log("data",data)
          setOrdersList(data?.data)
          return data?.data || [];
        } catch (error) {
          console.error("Error fetching open orders:", error);
          return [];
        }
      };
      
    useEffect(() => {
      fetchOpenOrders();
    }, [squareOffStatus,open]);

    useEffect(() => {
        if(traded == true){
            fetchOpenOrders();
            setTraded(false);
        }

      }, [traded]);

    const handleSquareOff = async (orders) => {
        try {
            setSquaringOff(true);
            // const authToken = getToken();
            console.log("orders", orders)
            const formData = {
                ltp:null,
                orders,
                broker_name: strategy.user_broker_account.broker,
                broker_user_id: strategy.user_broker_account.broker_user_id,
                broker_api_key: strategy.user_broker_account.broker_api_key,
            };
            console.log("formData", formData)

            const response = await SquareOffPositions(authToken, formData);

            console.log("squared off position Successfully:", response.data);
            message.success("squared off position Successfully!");

        } catch (error) {
            console.error("squared off position Failed:", error);
            message.error("Failed to squared off position. Please try again.");
        } finally {
            setSquaringOff(false);
        }
    };

    const handlePositiveInput = (e, setter, field) => {
        const value = e.target.value;

        if (value === "") {
            setter(value); // Allow blank input
            return;
        }

        const numValue = Number(value);

        if (isNaN(numValue) || numValue <= 0) {
            return; // Prevent negative values and non-numeric input
        }

        if (field === "stopLoss" && numValue > 100) {
            return; // Restrict stopLoss to max 100%
        }

        setter(value);
    };

    const handleSettingsClick = () => {
        setEditable(prev => !prev);
        setOpenStrategyEditor(prev => !prev);
        setOpenOrder(prev => {
            // On first click (when prev is true), set it to false
            // On second click (when prev is false), set it to true
            return !prev;
          });
    };

    const handleSaveClick = () => {
        handleSave();
        setInitialSL(stopLoss);
        setInitialTarget(target);
        setIsModified(false);
    };

    useEffect(() => {
        if (editable && (String(stopLoss) !== String(initialSL) || String(target) !== String(initialTarget))) {
            setIsModified(true);
        } else {
            setIsModified(false);
        }
    }, [stopLoss, target, editable]);

    return (
        <>
            <Button variant="contained" onClick={() => setOpen((prev) => !prev)}>
                {open ? "Close Tool" : "Open Tool"}
            </Button>
            <DraggableWrapper
                open={open}
                onClose={() => setOpen(false)}
                width={380}
                sx={{ overflow: "visible" }}
            >
                {
                    <>
                        <Box sx={{ my: 2, px: 1, display: 'flex', alignItems: 'center' }}>
                            {/* Amount Field */}
                            <TextField
                                label="Amount (₹)"
                                variant="outlined"
                                value={amount}
                                onChange={(e) => handlePositiveInput(e, setAmount)}
                                type="number"
                                sx={{
                                    width: "35%", // Set to 35% of the parent container width
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: 0, // Make borders sharp
                                    }
                                }}
                            />
                            <TextField
                                label="SL (%)"
                                variant="outlined"
                                value={stopLoss}
                                onChange={(e) => handlePositiveInput(e, setStopLoss, "stopLoss")}
                                type="number"
                                disabled={!editable}
                                sx={{
                                    width: "25%",
                                    mx: 1,
                                    "& .MuiOutlinedInput-root": { borderRadius: 0 }
                                }}
                            />
                            <TextField
                                label="T (%)"
                                variant="outlined"
                                value={target}
                                onChange={(e) => handlePositiveInput(e, setTarget, "target")}
                                type="number"
                                disabled={!editable}
                                sx={{
                                    width: "25%",
                                    "& .MuiOutlinedInput-root": { borderRadius: 0 }
                                }}
                            />
                            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "15%" }}>
                                <IconButton
                                    onClick={handleSaveClick}
                                    disabled={!isModified}
                                    sx={{
                                        p: 0,
                                        width: "24px",
                                        height: "24px",
                                        minWidth: "24px",
                                        minHeight: "24px",
                                        color: isModified ? "blue" : "gray",
                                        marginBottom: "4px"
                                    }}
                                >
                                    <SaveIcon sx={{ fontSize: "16px" }} />
                                </IconButton>

                                <IconButton
                                    onClick={() => handleSettingsClick()} // Fix: Wrap in an arrow function
                                    sx={{
                                        p: 0, // Remove padding
                                        width: "24px", // Set fixed small size
                                        height: "24px",
                                        minWidth: "24px",
                                        minHeight: "24px",
                                        color: "black"
                                    }}
                                >
                                    <SettingsIcon sx={{ fontSize: "16px" }} />
                                </IconButton>

                            </Box>

                        </Box>
                        {isModified && (
                            <Box sx={{ fontSize: "10px", textAlign: "center", color: "green", mt: 1 }}>
                                ✨ Changes detected. Click save button to update.
                            </Box>
                        )}

                        {/* Buy and Square Off Buttons */}
                        <Box display="flex" justifyContent="space-between" gap={1} sx={{ mt: 1 }}>
                            <Button
                                variant="contained"
                                sx={{ width: "30%", backgroundColor: "red", color: "white", '&:hover': { backgroundColor: "darkred" } }}
                                onClick={() => handleBuy("PE")}
                            >
                                Buy Put
                            </Button>
                            <Button
                                variant="contained"
                                sx={{ width: "30%", backgroundColor: "green", color: "white", '&:hover': { backgroundColor: "darkgreen" } }}
                                onClick={() => handleBuy("CE")}
                            >
                                Buy Call
                            </Button>

                            <Button
                                variant="contained"
                                color="secondary"
                                sx={{ width: "30%" }}
                                onClick={() => setOpenOrder(prev => !prev)}
                            >
                                PoS
                            </Button>

                        </Box>
                    </>
                }
                {openStrategyEditor && (
                    <Box sx={{ zIndex: 999999 }}>
                        {memoizedStrategyEditor}
                    </Box>
                )}

                {openOrder && (
                    <Box 
                    // sx={{ zIndex: 999999 }}
                    sx={{
                        border: '1px',
                        borderRadius: 1,
                      }}
                    paddingTop={1}
                    >
                        <OrderTable
                            orders={OrdersList}
                            squareOffStatus={squareOffStatus}
                            // ltpData={ltpData}
                            onSquareOff={handleSquareOff}
                            onSquareOffAll={handleSquareOff}
                        />
                    </Box>
                )}



            </DraggableWrapper>
        </>
    );
};

export default OptionBuyingTool;

